@if (display$ | async; as display) {
  <div class="live-status-indicator">
    <app-outline-badge
      [type]="display.badgeType"
      [label]="display.badgeLabel"
      [dot]="true"
      [rounded]="true"
    ></app-outline-badge>
    <span class="live-status-indicator__time">{{ display.timeLabel }}</span>
  </div>
}
